import Modal from './Modal'
import { useState } from 'react'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImages } from '@fortawesome/free-solid-svg-icons'


function Story(props) {
    const [modal, setModal] = useState(false)
    const { refStories } = props.route
    const [caption, setCaption] = useState(refStories[0]?.description)

    const onChange = (index) => {
        setCaption(refStories[index].description)
    }

    const renderInfo = () => {

        return <div className='story p-2'>
            <Carousel onChange={onChange} showThumbs={false} showIndicators={false} dynamicHeight={true} >
                {refStories && refStories.length > 0 && refStories.map((item) => {
                    return <div>
                        <img src={item?.refImage} alt="Story" width="100%" />
                    </div>
                })}
            </Carousel>
            <p className='mt-2'>{caption}</p>
        </div>
    }

    return <li className="beigeBox customShadow customRadius px-1 py-3 beigeBoxPointer">
            <div className="d-flex w-100 align-items-center justify-content-between" onClick={() => setModal(!modal)}>
                <div className='beigeBoxOnlyTitleWrap'>
                    
                    <h3>Story</h3>
                </div>
                <div className='beigeBoxOnlyIconWrap p-0'>
                    <FontAwesomeIcon icon={faImages}  />
                </div>
            </div>
            
        {modal && <Modal title="Story" modal={modal} toggleModal={setModal}>{renderInfo()}</Modal>}
    </li>
}


export default Story